import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMESTAMP_MULTIPLY, TIMEOUT_STORE} from 'util/constants';

const
    name = 'spendingByAccount',
    exports = storeModuleFactory({
        name,
        endpoint:        endpoints.spendingByConcept.endpoint,
        timeout:         TIMEOUT_STORE.TIMEOUT_STORE_MEDIUM,
        parseParameters: parameters => ({
            start_date: Math.floor(parameters.startDate / TIMESTAMP_MULTIPLY),
            end_date:   Math.floor(parameters.endDate / TIMESTAMP_MULTIPLY)
        }),
        transformResultsFn: json => [json],
        defaultParameters:  {
            by: 'account'
        }
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/spendingByAccount.js